let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];
  console.debug(`[PubSub] Subscribed to ${eventName}. Total subscribers: ${subscribers[eventName].length}`);

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
    console.debug(`[PubSub] Unsubscribed from ${eventName}. Remaining subscribers: ${subscribers[eventName] ? subscribers[eventName].length : 0}`);
  };
}

function publish(eventName, data) {
  console.debug(`[PubSub] Publishing ${eventName}`, data);
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
